<template>
  <el-dialog
    title="请输入解锁码"
    v-dialog-out
    append-to-body
    v-if="dialogVisible"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="hideDialog"
  >
    <div class="dialog-body">
      <el-form
        ref="form"
        :model="formData"
        :rules="formRules"
        label-width="80px"
      >
        <el-form-item size="small" label="解锁码 : " prop="password">
          <el-input
            ref="input"
            v-model="formData.password"
            :placeholder="'提示密码：' + placeholder"
            @keyup.enter.native="validateForm"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer">
      <el-button size="small" type="primary" @click="validateForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { password } from "@/api/apifoxInterface";

export default {
  name: "passwordDialog",
  components: {},
  props: {},
  computed: {
    permissionArr() {
      return this.$store.state.permission.permissionArr;
    },
  },
  data() {
    return {
      formData: {},
      formRules: {
        password: [
          { required: true, trigger: "blur", validator: this.validatePassword },
        ],
      },
      placeholder: "",
      dialogVisible: false,
      resPassword: null, // 管理员密码（可以查看未加密的信息）
      resEncPassword: null, // 访客的万能密码

      helpPassword: require("@/lib/json/apifox/password.json"),
    };
  },
  methods: {
    ...mapActions(["ADD_PERMISSION"]),

    showDialog() {
      if (localStorage.getItem("password") === null) {
        this.placeholder = this.$store.state.auth.password.randomNum;
      } else {
        this.placeholder = JSON.parse(
          localStorage.getItem("password")
        ).randomNum;
      }
      this.dialogVisible = true;
      this.autoFocus();
      this.getPassword();
    },

    /**
     * @Event 输入框实现自动聚焦
     * @description:
     * @author: mhf
     * @time: 2024-01-14 12:47:03
     **/
    autoFocus() {
      this.$nextTick(() => {
        let input = this.$refs.input;
        if (input) {
          input.focus();
        }
      });
    },

    /**
     * @Interface 接口
     * @description: 获取万能解锁密码
     * */
    getPassword() {
      password().then((res) => {
        if (res.data.code === 200) {
          this.resPassword = res.data.data.password;
          this.resEncPassword = res.data.data.encPassword;
        }

        if (res.data.code === 504) {
          /* 网络错误，使用本地数据 */
          this.resPassword = this.helpPassword.data.password;
          this.resEncPassword = this.helpPassword.data.encPassword;
        }
      });
    },

    hideDialog() {
      this.formData = {};
      if (
        this.$store.state.auth.permission.id === 1 ||
        !localStorage.getItem("permission")
      ) {
        this.$parent.moveTo("index?page=1");
      }
      this.dialogVisible = false;
    },

    validatePassword(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入解锁码"));
      } else {
        let resNum = this.placeholder * this.placeholder + this.placeholder; // n² + n
        if (
          parseFloat(value) === resNum ||
          parseFloat(value) === this.resEncPassword + 1
        ) {
          this.ADD_PERMISSION(
            this.permissionArr.filter((per) => per.id === 2)[0]
          );
          callback();
        } else if (parseFloat(value) === this.resPassword + 1) {
          this.ADD_PERMISSION(
            this.permissionArr.filter((per) => per.id === 3)[0]
          );
          callback();
        } else {
          this.ADD_PERMISSION(
            this.permissionArr.filter((per) => per.id === 1)[0]
          );
          callback(new Error("解锁码不正确！"));
        }
      }
    },

    validateForm() {
      console.log("validateForm");
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitForm();
        } else {
          return false;
        }
      });
    },

    submitForm() {
      this.$message.success("解锁成功！");
      this.hideDialog();
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  background-color: #ffcdea;
  width: 400px;
  border-radius: 10px !important;
}

::v-deep .el-dialog__header {
  background-color: #e7a4ff;
  border-radius: 10px 10px 0 0 !important;
  padding: 4px 20px 4px;
}

::v-deep .el-dialog__title {
  font-size: 14px;
  color: #fff;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  position: absolute;
  top: -10px;
  right: -10px;
}

::v-deep .el-dialog__headerbtn .el-dialog__close:hover {
  color: #ad76ff;
}

::v-deep .el-dialog__footer {
  text-align: center !important;
}

::v-deep .el-button--primary {
  background-color: #37fcac;
  border: 1px solid #37fcac;
  color: #000;
  width: 70px;
}

::v-deep .el-button--primary:focus,
.el-button--primary:hover {
  background-color: #2fe59b;
  border: 1px solid #2fe59b;
  color: #fff;
}

::v-deep .el-input--small .el-input__inner {
  border: 1px solid #a9a9a9;
}

.el-dialog__wrapper {
  background-color: #ad76ff !important;
}
</style>
